export default __webpack_public_path__ + "media/images/logo-rgp-2738d25b08c0c3f7aff7424145ff879f.png";